import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

export default function AccessDeniedPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 2,
      }}
    >
      <Typography variant="h4" component="h1">
        Access denied
      </Typography>
      <Typography variant="body1" color="text.secondary" align="center">
        You do not have permission to view this page. Contact your organisation administrator
        if you believe this is a mistake.
      </Typography>
      <Button variant="contained" onClick={() => navigate(ROUTES.DASHBOARD.HUB)}>
        Go to Dashboard
      </Button>
    </Box>
  );
}
